<template lang="pug">
  .padding-container.create-document
    Notice.success(v-if="success" :top="true") {{ $t('pages.single_document.success') }}
      router-link(to="/documents/view-documents") {{ $t('pages.view_documents.title') }}
    .flex-grid
      loading(:active.sync="loading")
      div.account
        h4.b-margin-sm {{ $t('pages.create_document.titles.document') }}
        hr
        .input-group  
          label {{ $t('fields.name') }}*
          input(v-model="object.name" :placeholder="$t('fields.name')")
        .flex-grid
          .input-group  
            label {{ $t('fields.type') }}*
            input(v-model="object.type" :placeholder="$t('fields.type')")
          .input-group
            label {{ $t('fields.template')}}
            select.select(v-model="object.is_template")
              option(:value="true") Template
              option(:value="false") Bespoke
            Notice.small(v-if="object.is_template == false") This is a bespoke document, it will only appear for users assigned to this.
        .flex-grid
          .input-group
            label {{ $t('fields.publish_date') }}
            datepicker(ref="publishDatePicker" :date="object.publish_date" @input="dateChanged")
          .input-group
            label {{ $t('fields.published')}}
            select.select(v-model="object.published")
              option(:value="true") True
              option(:value="false") False
          .input-group
            label {{ $t('fields.requires_premium')}}
            select.select(v-model="object.requires_premium")
              option(:value="true") True
              option(:value="false") False
        .input-group  
          label {{ $t('fields.current_file') }}*
          input(readonly v-model="object.file_name" :placeholder="$t('error_messages.not_set')")
        .input-group
          FileUpload(:choose_text="$t('interface.upload_new_file')" @input="changedFile" @removedFile="removedFile")
        .flex-grid
          .creator(@click="saveDocument")
            Button(:text="$t('interface.save')")
          .deletor(@click="crudDelete(object.id, delete_form, service)")
            Button(type="primary" :text="$t('interface.delete')")
          //- .creator(@click="crudCreate(object, object_form, service)")
      div.groups
        //- h4.b-margin-sm {{ $t('pages.create_document.titles.groups') }}
        //- hr
        //- .input-group
          //- GroupSelector(v-if="loading == false" :selected="groups_selected" @input="changedGroup")
    Notice(v-if="error") {{ error }}

</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  import moment from 'moment';

  import VoerroTagsInput from '@voerro/vue-tagsinput';

  import DocumentService from '@/services/document';
  import Api from '@/services/api'

  import Notice from '@/components/Notice';
  // import GroupSelector from '@/components/inputs/GroupSelector';
  import FileUpload from '@/components/inputs/FileUpload';

  export default {
    data: function() {
      return {
        service: DocumentService,
        loading: true,
        success: '',
        error: '',
        file: null,
        file_name: null,
        object: {
          publish_date: moment().format('llll'),
          published: true,
          requires_premium: true,
          is_template: true,
          name: '',
          type: ''
        },
        object_form: {
          title: this.$t('pages.create_document.prompt_confirm_title'),
          text: this.$t('pages.create_document.prompt_confirm_text')
        },
        delete_form: {
          title: this.$t('pages.single_document.prompt_delete_title'),
          text: this.$t('pages.single_document.prompt_delete_text')
        }
      }
    },
    methods: {

      async GET_SINGLE(page) {
        const id = this.$router.currentRoute.params.id;
        this.crudGet({ id: id }, DocumentService)
      },

      saveDocument: async function(e) {
        let THISINSTANCE = this;
        let rawData = this.object;
        let formData = new FormData()
        let invalid = false;

        if(this.file == null) {
          this.file = null;
          this.file_name = null;
        }

        Object.keys(this.object).forEach(key => {
          const item = this.object[key];
          if(item != null && item != '' || item === false ) // we want to allow false booleans!
            formData.append( [key], JSON.stringify(item) )

          if(key === 'name') {
            if(item === '') {
              THISINSTANCE.error = THISINSTANCE.$i18n.t('error_messages.field_required', { 
                text: THISINSTANCE.$i18n.t('fields.name')
              })
              invalid = true;
            }
          }
        })

        if(invalid == false)
          this.error = null;

        if(this.error == null) {

          if(this.file)
            formData.append('file', this.file, this.file_name)

          const headers = { 'Content-Type': 'multipart/form-data' };
          // UPDATE!
          Api().put(`document/${this.object.id}`, formData, headers )
            .then(response => {
              this.error = null;
              this.success = THISINSTANCE.$i18n.t('pages.single_document.success');
              this.GET_SINGLE();
            })
            .catch(err => {
              this.error = THISINSTANCE.$i18n.t('error_messages.' + err.response.data)
              this.success = null;
            })
        }


      },

      objChange: function(string, e) {
        this[string] = e;
      },
      changedGroup: function(e) {
        this.object.groups = e;
      },
      dateChanged: function(e) {
        this.object.publish_date = e;
      },
      removedFile: function(e) {
        this.file = null;
        this.file_name = null;
      },
      changedFile: function(e) {
        this.file = e;
        this.file_name = e.name;
      }
    },
    created() {

      this.GET_SINGLE();

      this.$on('loading', function (e) {
        this.loading = e;
      })
      this.$on('error', function (e) {
        this.error = e;
        this.success = '';
      })

      this.$on('deleted', function(e) {
        this.$swal.fire({
          title: this.$t('interface.success'),
          text: this.$t('interface.deleted_success')
        })
        this.$router.go('-1')
      });

      this.$on('get', function (e) {
        const data = e.data;
        const allowed_fields = ['name','file_name', 'type', 'is_template', 'requires_premium','published','publish_date','id'];
        let item = this;

        allowed_fields.forEach(field => {
          item.object[field] = data[field];
        })

        // groups exist..
        if(this.object.groups) {
          if(this.object.groups.length > 0) {
            this.groups_selected = this.object.groups;
          }
        }

        const formatted_date = moment(data.publish_date, 'DD/MM/YYYY HH:mm:ss');

        this.$refs.publishDatePicker.local_date = formatted_date;
        this.object.publish_date = formatted_date.format('llll');

        this.object.file_name = data.file_name;

        this.loading = false;
        this.error = '';
      })

      this.$on('updated', function (e) {
        this.success = e;
        this.loading = false;
        this.error = '';

        // this.object = e;
        this.GET_SINGLE();
      })
    },
    components: { 
      "tags-input": VoerroTagsInput, 
      // GroupSelector,
      FileUpload,
      Loading,
      Notice
    }
  }
</script>